import { render, staticRenderFns } from "./RetourPaillettes.vue?vue&type=template&id=288dfcd5&"
import script from "./RetourPaillettes.vue?vue&type=script&lang=js&"
export * from "./RetourPaillettes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports